var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "control" }, [
    _c(
      "div",
      { staticClass: "control__elements" },
      [
        _c(
          "input",
          _vm._b(
            {
              ref: _vm.refName ? _vm.refName : "input",
              staticClass: "control-input",
              class: { "is-error": _vm.errors[0] },
              attrs: { type: "text" },
              domProps: { value: _vm.value },
              on: {
                focus: function($event) {
                  _vm.$emit("focus")
                  _vm.inputMaskTrigger(true)
                },
                blur: function($event) {
                  _vm.$emit("blur")
                  _vm.inputMaskTrigger(false)
                },
                keypress: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.$emit("enter")
                },
                input: function($event) {
                  return _vm.$emit("input", $event.target.value)
                }
              }
            },
            "input",
            [_vm.$props, _vm.$attrs],
            false
          )
        ),
        _vm.label
          ? _c(
              "div",
              {
                staticClass: "control__label",
                class: {
                  "is-active": _vm.value || _vm.maskIsActive ? true : false
                }
              },
              [_c("label", [_vm._v(_vm._s(_vm.label))])]
            )
          : _vm._e(),
        _vm._t("icon")
      ],
      2
    ),
    _vm.errors[0]
      ? _c("div", { staticClass: "control__meta" }, [
          _c("div", { staticClass: "control__help" }, [
            _c(
              "span",
              {
                staticClass: "help help--type_error",
                class: { "is-error": _vm.errors[0] }
              },
              [_vm._v(_vm._s(_vm.errors[0]))]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8bf466ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bf466ee","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Input/Input.vue
// module id = 931
// module chunks = 0